module.exports = __webpack_public_path__ + "static/media/wdu_logo.aa5dc23f.svg";